var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"plugin-icon-box",style:({
    backgroundColor: _vm.iconBgColor,
    width: _vm.$vw(_vm.size),
    height: _vm.$vw(_vm.size),
    borderRadius: _vm.$vw(_vm.iconBorderRadius)
  })},[_c('van-icon',{staticClass:"plugin-icon",attrs:{"size":_vm.$vw(_vm.iconSize),"class-prefix":"icon","color":_vm.iconColor,"name":_vm.icon}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }